import { render, staticRenderFns } from "./AddItemButton.vue?vue&type=template&id=107b3756&"
import script from "./AddItemButton.vue?vue&type=script&lang=ts&"
export * from "./AddItemButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports